import { Constraints_minConstraint, Constraints_minMaxConstraint, Constraints_minMaxOptLengthConstraint, Constraints_collectConstraintsErrors, Constraints_applyConstraintsGetErrors, Constraints_minMaxLengthConstraint } from "../Omnicv.Shared.Common/Validation.js";
import { head, empty, isEmpty, ofSeq, ofArray, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { FSharpMap__get_Keys, tryFind } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, enum_type, unit_type, lambda_type, list_type, tuple_type, int32_type, record_type, string_type, option_type, class_type, float64_type, int64_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { parse, addSeconds, compare } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { compare as compare_1, round } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { PagingOptions_$reflection, EventInfo_$reflection } from "../Omnicv.Shared.Common/CoreEventInfo.js";
import { ChangelogEntry, Version, ProductInformation, Changelog, defaultWeb, defaultContacts, defaultAuthors } from "../Omnicv.Shared.Common/ProductDetails.js";

export const MaxWorkoutDurationSec = (3 * 60) * 60;

const nameConstraints = singleton((name) => ((value) => Constraints_minMaxLengthConstraint(1, 256, name, value)));

export const nameName = "Name";

function getNameErrors(name) {
    return Constraints_applyConstraintsGetErrors(nameConstraints, nameName, name);
}

export function validateName(name) {
    return tryFind(nameName, Constraints_collectConstraintsErrors(singleton(getNameErrors(name))));
}

const descriptionConstraints = singleton((name) => ((value) => Constraints_minMaxLengthConstraint(5, 1000, name, value)));

export const descriptionName = "Description";

function getDescriptionErrors(description) {
    return Constraints_applyConstraintsGetErrors(descriptionConstraints, descriptionName, description);
}

export function validateDescription(description) {
    return tryFind(descriptionName, Constraints_collectConstraintsErrors(singleton(getDescriptionErrors(description))));
}

const instructionsConstraints = singleton((name) => ((value) => Constraints_minMaxLengthConstraint(5, 1000, name, value)));

export const instructionsName = "Instructions";

function getInstructionsErrors(instructions) {
    return Constraints_applyConstraintsGetErrors(instructionsConstraints, instructionsName, instructions);
}

export function validateInstructions(instructions) {
    return tryFind(instructionsName, Constraints_collectConstraintsErrors(singleton(getInstructionsErrors(instructions))));
}

const notesConstraints = singleton((name) => ((value) => Constraints_minMaxOptLengthConstraint(5, 1000, name, value)));

export const notesName = "Notes";

function getNotesErrors(notes) {
    return Constraints_applyConstraintsGetErrors(notesConstraints, notesName, notes);
}

export function validateNotes(notes) {
    return tryFind(notesName, Constraints_collectConstraintsErrors(singleton(getNotesErrors(notes))));
}

const weightConstraints = singleton((name) => ((value) => Constraints_minMaxConstraint(0.1, 10000, name, value)));

export const weightName = "Weight";

function getWeightErrors(weight) {
    return Constraints_applyConstraintsGetErrors(weightConstraints, weightName, weight);
}

export function validateWeight(weight) {
    return tryFind(weightName, Constraints_collectConstraintsErrors(singleton(getWeightErrors(weight))));
}

const repetitionsConstraints = singleton((name) => ((value) => Constraints_minConstraint(1, name, value)));

export const repetitionsName = "Repetitions";

function getRepetitionsErrors(repetitions) {
    return Constraints_applyConstraintsGetErrors(repetitionsConstraints, repetitionsName, repetitions);
}

export function validateRepetitions(repetitions) {
    return tryFind(repetitionsName, Constraints_collectConstraintsErrors(singleton(getRepetitionsErrors(repetitions))));
}

export class WorkoutRecord extends Record {
    constructor(Id, WorkoutId, Progress, FinishTime, Notes) {
        super();
        this.Id = Id;
        this.WorkoutId = WorkoutId;
        this.Progress = Progress;
        this.FinishTime = FinishTime;
        this.Notes = Notes;
    }
}

export function WorkoutRecord_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.WorkoutRecord", [], WorkoutRecord, () => [["Id", int64_type], ["WorkoutId", int64_type], ["Progress", float64_type], ["FinishTime", option_type(class_type("System.DateTime"))], ["Notes", option_type(string_type)]]);
}

export function WorkoutRecord_Default_Z524259C1(workoutId) {
    return new WorkoutRecord(0n, workoutId, 0, undefined, undefined);
}

function WorkoutRecord_Validator_42A60C18(record) {
    return Constraints_collectConstraintsErrors(singleton(getNotesErrors(record.Notes)));
}

export function WorkoutRecord__Validate(this$) {
    return WorkoutRecord_Validator_42A60C18(this$);
}

export function WorkoutRecord__IsActive(this$, eventInfo, now) {
    if (this$.FinishTime == null) {
        return compare(addSeconds(eventInfo.EventTimestamp, MaxWorkoutDurationSec), now) >= 0;
    }
    else {
        return false;
    }
}

export class RepsWithWeightRecord extends Record {
    constructor(Id, ExerciseId, WorkoutRecordId, Repetitions, Weight, Notes) {
        super();
        this.Id = Id;
        this.ExerciseId = ExerciseId;
        this.WorkoutRecordId = WorkoutRecordId;
        this.Repetitions = (Repetitions | 0);
        this.Weight = Weight;
        this.Notes = Notes;
    }
}

export function RepsWithWeightRecord_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.RepsWithWeightRecord", [], RepsWithWeightRecord, () => [["Id", int64_type], ["ExerciseId", int64_type], ["WorkoutRecordId", option_type(int64_type)], ["Repetitions", int32_type], ["Weight", float64_type], ["Notes", option_type(string_type)]]);
}

export function RepsWithWeightRecord_Default_Z524259C1(exerciseId) {
    return new RepsWithWeightRecord(0n, exerciseId, undefined, 0, 0, undefined);
}

function RepsWithWeightRecord_Validator_Z37655B9F(record) {
    return Constraints_collectConstraintsErrors(ofArray([getRepetitionsErrors(record.Repetitions), getNotesErrors(record.Notes), getWeightErrors(record.Weight)]));
}

export function RepsWithWeightRecord__Validate(this$) {
    return RepsWithWeightRecord_Validator_Z37655B9F(this$);
}

export function RepsWithWeightRecord__E1RM(this$) {
    return this$.Weight + ((this$.Weight * this$.Repetitions) / 30);
}

export function RepsWithWeightRecord__E1RMDisplay(this$) {
    const value = RepsWithWeightRecord__E1RM(this$);
    if (value >= 10) {
        return round(value);
    }
    else {
        return round(value, 2);
    }
}

export class RepsWithBodyWeightRecord extends Record {
    constructor(Id, ExerciseId, WorkoutRecordId, Repetitions, Notes) {
        super();
        this.Id = Id;
        this.ExerciseId = ExerciseId;
        this.WorkoutRecordId = WorkoutRecordId;
        this.Repetitions = (Repetitions | 0);
        this.Notes = Notes;
    }
}

export function RepsWithBodyWeightRecord_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.RepsWithBodyWeightRecord", [], RepsWithBodyWeightRecord, () => [["Id", int64_type], ["ExerciseId", int64_type], ["WorkoutRecordId", option_type(int64_type)], ["Repetitions", int32_type], ["Notes", option_type(string_type)]]);
}

export function RepsWithBodyWeightRecord_Default_Z524259C1(exerciseId) {
    return new RepsWithBodyWeightRecord(0n, exerciseId, undefined, 0, undefined);
}

export class EnduranceRecord extends Record {
    constructor(Id, ExerciseId, WorkoutRecordId, DurationSec, DistanceKm, Calories, Notes) {
        super();
        this.Id = Id;
        this.ExerciseId = ExerciseId;
        this.WorkoutRecordId = WorkoutRecordId;
        this.DurationSec = (DurationSec | 0);
        this.DistanceKm = DistanceKm;
        this.Calories = Calories;
        this.Notes = Notes;
    }
}

export function EnduranceRecord_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.EnduranceRecord", [], EnduranceRecord, () => [["Id", int64_type], ["ExerciseId", int64_type], ["WorkoutRecordId", option_type(int64_type)], ["DurationSec", int32_type], ["DistanceKm", float64_type], ["Calories", option_type(int32_type)], ["Notes", option_type(string_type)]]);
}

export function EnduranceRecord_Default_Z524259C1(exerciseId) {
    return new EnduranceRecord(0n, exerciseId, undefined, 0, 0, undefined, undefined);
}

export class IntervalsDurationRecord extends Record {
    constructor(Id, ExerciseId, WorkoutRecordId, NumExercises, WorkDurationSec, RestDurationSec, Notes) {
        super();
        this.Id = Id;
        this.ExerciseId = ExerciseId;
        this.WorkoutRecordId = WorkoutRecordId;
        this.NumExercises = (NumExercises | 0);
        this.WorkDurationSec = (WorkDurationSec | 0);
        this.RestDurationSec = (RestDurationSec | 0);
        this.Notes = Notes;
    }
}

export function IntervalsDurationRecord_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.IntervalsDurationRecord", [], IntervalsDurationRecord, () => [["Id", int64_type], ["ExerciseId", int64_type], ["WorkoutRecordId", option_type(int64_type)], ["NumExercises", int32_type], ["WorkDurationSec", int32_type], ["RestDurationSec", int32_type], ["Notes", option_type(string_type)]]);
}

export function IntervalsDurationRecord_Default_Z524259C1(exerciseId) {
    return new IntervalsDurationRecord(0n, exerciseId, undefined, 0, 0, 0, undefined);
}

export class IntervalsRepsRecord extends Record {
    constructor(Id, ExerciseId, WorkoutRecordId, NumExercises, WorkRepetitions, RestDurationSec, Notes) {
        super();
        this.Id = Id;
        this.ExerciseId = ExerciseId;
        this.WorkoutRecordId = WorkoutRecordId;
        this.NumExercises = (NumExercises | 0);
        this.WorkRepetitions = (WorkRepetitions | 0);
        this.RestDurationSec = (RestDurationSec | 0);
        this.Notes = Notes;
    }
}

export function IntervalsRepsRecord_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.IntervalsRepsRecord", [], IntervalsRepsRecord, () => [["Id", int64_type], ["ExerciseId", int64_type], ["WorkoutRecordId", option_type(int64_type)], ["NumExercises", int32_type], ["WorkRepetitions", int32_type], ["RestDurationSec", int32_type], ["Notes", option_type(string_type)]]);
}

export function IntervalsRepsRecord_Default_Z524259C1(exerciseId) {
    return new IntervalsRepsRecord(0n, exerciseId, undefined, 0, 0, 0, undefined);
}

export class FitnessSearchOptions extends Record {
    constructor(DateFrom, DateTo, Notes) {
        super();
        this.DateFrom = DateFrom;
        this.DateTo = DateTo;
        this.Notes = Notes;
    }
}

export function FitnessSearchOptions_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.FitnessSearchOptions", [], FitnessSearchOptions, () => [["DateFrom", option_type(class_type("System.DateTime"))], ["DateTo", option_type(class_type("System.DateTime"))], ["Notes", option_type(string_type)]]);
}

export function FitnessSearchOptions__Validate(this$) {
    if (((this$.DateFrom == null) && (this$.DateTo == null)) && (this$.Notes == null)) {
        return "At least one parameter must be populated";
    }
    else if (((this$.DateFrom != null) && (this$.DateTo != null)) && (compare_1(this$.DateFrom, this$.DateTo) >= 0)) {
        return "From must be smaller than To";
    }
    else {
        return undefined;
    }
}

export class FitnessEditHelperData extends Record {
    constructor(FrequentTags) {
        super();
        this.FrequentTags = FrequentTags;
    }
}

export function FitnessEditHelperData_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.FitnessEditHelperData", [], FitnessEditHelperData, () => [["FrequentTags", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, int32_type])]]);
}

export function FitnessEditHelperData__GetFrequentTags(this$) {
    return ofSeq(FSharpMap__get_Keys(this$.FrequentTags));
}

export class Exercise extends Record {
    constructor(Id, ProfileId, Name, Description, Instructions, ContentTypeId, CreatedAt, UpdatedAt, Categories) {
        super();
        this.Id = Id;
        this.ProfileId = ProfileId;
        this.Name = Name;
        this.Description = Description;
        this.Instructions = Instructions;
        this.ContentTypeId = (ContentTypeId | 0);
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
        this.Categories = Categories;
    }
}

export function Exercise_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.Exercise", [], Exercise, () => [["Id", int64_type], ["ProfileId", option_type(int32_type)], ["Name", string_type], ["Description", string_type], ["Instructions", string_type], ["ContentTypeId", int32_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")], ["Categories", string_type]]);
}

function Exercise_Validator_7CDB074C(record) {
    return Constraints_collectConstraintsErrors(ofArray([getNameErrors(record.Name), getDescriptionErrors(record.Description), getInstructionsErrors(record.Instructions)]));
}

export function Exercise__Validate(this$) {
    return Exercise_Validator_7CDB074C(this$);
}

export function Exercise_Default_7F9DDECF(timestamp) {
    return new Exercise(0n, 0, "", "", "", 0, timestamp, timestamp, "");
}

export class ExerciseRecordAddingInfo$1 extends Record {
    constructor(ExerciseRecords, Exercise) {
        super();
        this.ExerciseRecords = ExerciseRecords;
        this.Exercise = Exercise;
    }
}

export function ExerciseRecordAddingInfo$1_$reflection(gen0) {
    return record_type("Omnicv.Shared.FitnessAPI.ExerciseRecordAddingInfo`1", [gen0], ExerciseRecordAddingInfo$1, () => [["ExerciseRecords", list_type(tuple_type(EventInfo_$reflection(), gen0))], ["Exercise", Exercise_$reflection()]]);
}

export class RecordService$1 extends Record {
    constructor(Add, AddMany, Edit, GetRecord, GetRecords, GetExerciseRecords, GetExerciseRecordAddingInfo, SearchRecords) {
        super();
        this.Add = Add;
        this.AddMany = AddMany;
        this.Edit = Edit;
        this.GetRecord = GetRecord;
        this.GetRecords = GetRecords;
        this.GetExerciseRecords = GetExerciseRecords;
        this.GetExerciseRecordAddingInfo = GetExerciseRecordAddingInfo;
        this.SearchRecords = SearchRecords;
    }
}

export function RecordService$1_$reflection(gen0) {
    return record_type("Omnicv.Shared.FitnessAPI.RecordService`1", [gen0], RecordService$1, () => [["Add", lambda_type(EventInfo_$reflection(), lambda_type(gen0, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [EventInfo_$reflection()])))], ["AddMany", lambda_type(EventInfo_$reflection(), lambda_type(list_type(gen0), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["Edit", lambda_type(EventInfo_$reflection(), lambda_type(gen0, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [EventInfo_$reflection()])))], ["GetRecord", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [tuple_type(EventInfo_$reflection(), gen0)])))], ["GetRecords", lambda_type(int32_type, lambda_type(PagingOptions_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(tuple_type(EventInfo_$reflection(), gen0))])))], ["GetExerciseRecords", lambda_type(int32_type, lambda_type(int64_type, lambda_type(PagingOptions_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(tuple_type(EventInfo_$reflection(), gen0))]))))], ["GetExerciseRecordAddingInfo", lambda_type(int32_type, lambda_type(int64_type, lambda_type(PagingOptions_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [ExerciseRecordAddingInfo$1_$reflection(gen0)]))))], ["SearchRecords", lambda_type(int32_type, lambda_type(FitnessSearchOptions_$reflection(), lambda_type(PagingOptions_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(tuple_type(EventInfo_$reflection(), gen0))]))))]]);
}

export class Workout extends Record {
    constructor(Id, ProfileId, Name, WorkoutType, Description, Schedule, CreatedAt, UpdatedAt, Categories) {
        super();
        this.Id = Id;
        this.ProfileId = ProfileId;
        this.Name = Name;
        this.WorkoutType = (WorkoutType | 0);
        this.Description = Description;
        this.Schedule = Schedule;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
        this.Categories = Categories;
    }
}

export function Workout_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.Workout", [], Workout, () => [["Id", int64_type], ["ProfileId", option_type(int32_type)], ["Name", string_type], ["WorkoutType", enum_type("Omnicv.Shared.FitnessAPI.WorkoutType", int32_type, [["Regular", 1], ["Circuit", 2]])], ["Description", string_type], ["Schedule", option_type(string_type)], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")], ["Categories", string_type]]);
}

function Workout_Validator_Z4E1030EB(record) {
    return Constraints_collectConstraintsErrors(ofArray([getNameErrors(record.Name), getDescriptionErrors(record.Description)]));
}

export function Workout__Validate(this$) {
    return Workout_Validator_Z4E1030EB(this$);
}

export function Workout_Default_7F9DDECF(timestamp) {
    return new Workout(0n, 0, "", 1, "", undefined, timestamp, timestamp, "");
}

export class TrainingPlan extends Record {
    constructor(Id, ProfileId, Name, Description, CreatedAt, UpdatedAt, Categories) {
        super();
        this.Id = Id;
        this.ProfileId = ProfileId;
        this.Name = Name;
        this.Description = Description;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
        this.Categories = Categories;
    }
}

export function TrainingPlan_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.TrainingPlan", [], TrainingPlan, () => [["Id", int64_type], ["ProfileId", option_type(int32_type)], ["Name", string_type], ["Description", string_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")], ["Categories", string_type]]);
}

export function TrainingPlan_Default_7F9DDECF(timestamp) {
    return new TrainingPlan(0n, 0, "", "", timestamp, timestamp, "");
}

function TrainingPlan_Validator_Z1F153657(record) {
    return Constraints_collectConstraintsErrors(ofArray([getNameErrors(record.Name), getDescriptionErrors(record.Description)]));
}

export function TrainingPlan__Validate(this$) {
    return TrainingPlan_Validator_Z1F153657(this$);
}

export class ExerciseRecord extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["RepsWithWeight", "RepsWithBodyWeight", "Endurance", "IntervalsDuration", "IntervalsReps"];
    }
}

export function ExerciseRecord_$reflection() {
    return union_type("Omnicv.Shared.FitnessAPI.ExerciseRecord", [], ExerciseRecord, () => [[["Item", RepsWithWeightRecord_$reflection()]], [["Item", RepsWithBodyWeightRecord_$reflection()]], [["Item", EnduranceRecord_$reflection()]], [["Item", IntervalsDurationRecord_$reflection()]], [["Item", IntervalsRepsRecord_$reflection()]]]);
}

export function getWorkoutId(record_, record__1) {
    const matchValue = record__1;
    switch (matchValue.tag) {
        case 1:
            return matchValue.fields[0].WorkoutRecordId;
        case 2:
            return matchValue.fields[0].WorkoutRecordId;
        case 3:
            return matchValue.fields[0].WorkoutRecordId;
        case 4:
            return matchValue.fields[0].WorkoutRecordId;
        default:
            return matchValue.fields[0].WorkoutRecordId;
    }
}

export function getExerciseId(record_, record__1) {
    const matchValue = record__1;
    switch (matchValue.tag) {
        case 1:
            return matchValue.fields[0].ExerciseId;
        case 2:
            return matchValue.fields[0].ExerciseId;
        case 3:
            return matchValue.fields[0].ExerciseId;
        case 4:
            return matchValue.fields[0].ExerciseId;
        default:
            return matchValue.fields[0].ExerciseId;
    }
}

export class WorkoutLog extends Record {
    constructor(Workouts, Exercises, RecentWorkoutRecords, RecentExerciseRecords) {
        super();
        this.Workouts = Workouts;
        this.Exercises = Exercises;
        this.RecentWorkoutRecords = RecentWorkoutRecords;
        this.RecentExerciseRecords = RecentExerciseRecords;
    }
}

export function WorkoutLog_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.WorkoutLog", [], WorkoutLog, () => [["Workouts", list_type(Workout_$reflection())], ["Exercises", list_type(Exercise_$reflection())], ["RecentWorkoutRecords", list_type(tuple_type(EventInfo_$reflection(), WorkoutRecord_$reflection()))], ["RecentExerciseRecords", list_type(tuple_type(EventInfo_$reflection(), ExerciseRecord_$reflection()))]]);
}

export function WorkoutLog__IsEmpty(this$) {
    if (isEmpty(this$.RecentExerciseRecords)) {
        return isEmpty(this$.RecentWorkoutRecords);
    }
    else {
        return false;
    }
}

export class FitnessHierarchy extends Record {
    constructor(Favourites, TrainingPlans, WorkoutLog) {
        super();
        this.Favourites = Favourites;
        this.TrainingPlans = TrainingPlans;
        this.WorkoutLog = WorkoutLog;
    }
}

export function FitnessHierarchy_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.FitnessHierarchy", [], FitnessHierarchy, () => [["Favourites", list_type(tuple_type(int64_type, Favourite_$reflection()))], ["TrainingPlans", list_type(TrainingPlanData_$reflection())], ["WorkoutLog", WorkoutLog_$reflection()]]);
}

export class Favourite extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Exercise", "Workout", "TrainingPlan"];
    }
}

export function Favourite_$reflection() {
    return union_type("Omnicv.Shared.FitnessAPI.Favourite", [], Favourite, () => [[["Item", Exercise_$reflection()]], [["Item", Workout_$reflection()]], [["Item", TrainingPlan_$reflection()]]]);
}

export class TrainingPlanData extends Record {
    constructor(TrainingPlan, Workouts) {
        super();
        this.TrainingPlan = TrainingPlan;
        this.Workouts = Workouts;
    }
}

export function TrainingPlanData_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.TrainingPlanData", [], TrainingPlanData, () => [["TrainingPlan", TrainingPlan_$reflection()], ["Workouts", list_type(WorkoutData_$reflection())]]);
}

export class WorkoutData extends Record {
    constructor(Workout, Exercises) {
        super();
        this.Workout = Workout;
        this.Exercises = Exercises;
    }
}

export function WorkoutData_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.WorkoutData", [], WorkoutData, () => [["Workout", Workout_$reflection()], ["Exercises", list_type(Exercise_$reflection())]]);
}

export class WorkoutCircuitData extends Record {
    constructor(Workout, Exercises, WorkoutRecords, ExerciseRecords) {
        super();
        this.Workout = Workout;
        this.Exercises = Exercises;
        this.WorkoutRecords = WorkoutRecords;
        this.ExerciseRecords = ExerciseRecords;
    }
}

export function WorkoutCircuitData_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.WorkoutCircuitData", [], WorkoutCircuitData, () => [["Workout", Workout_$reflection()], ["Exercises", list_type(Exercise_$reflection())], ["WorkoutRecords", list_type(tuple_type(EventInfo_$reflection(), WorkoutRecord_$reflection()))], ["ExerciseRecords", list_type(tuple_type(EventInfo_$reflection(), ExerciseRecord_$reflection()))]]);
}

export class TrainingPlanWorkoutRecords extends Record {
    constructor(TrainingPlan, WorkoutRecords) {
        super();
        this.TrainingPlan = TrainingPlan;
        this.WorkoutRecords = WorkoutRecords;
    }
}

export function TrainingPlanWorkoutRecords_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.TrainingPlanWorkoutRecords", [], TrainingPlanWorkoutRecords, () => [["TrainingPlan", TrainingPlan_$reflection()], ["WorkoutRecords", list_type(tuple_type(EventInfo_$reflection(), WorkoutRecord_$reflection()))]]);
}

export class WorkoutRecords extends Record {
    constructor(Workout, WorkoutRecords) {
        super();
        this.Workout = Workout;
        this.WorkoutRecords = WorkoutRecords;
    }
}

export function WorkoutRecords_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.WorkoutRecords", [], WorkoutRecords, () => [["Workout", Workout_$reflection()], ["WorkoutRecords", list_type(tuple_type(EventInfo_$reflection(), WorkoutRecord_$reflection()))]]);
}

export class WorkoutRecordType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Active", "NewForWorkout", "None"];
    }
}

export function WorkoutRecordType_$reflection() {
    return union_type("Omnicv.Shared.FitnessAPI.WorkoutRecordType", [], WorkoutRecordType, () => [[], [["Item", int64_type]], []]);
}

export class FitnessService extends Record {
    constructor(GetHierarchy, GetExercise, GetExercises, AddExercise, EditExercise, DeleteExercise, StartActiveWorkoutRecord, ConcludeActiveWorkoutRecord, DeleteActiveWorkoutRecord, DeleteWorkoutRecord, EditWorkoutRecord, GetWorkoutRecord, AddExerciseRecords, GetExerciseRecords, GetExerciseRecord, MarkExerciseFavourite, GetWorkout, GetWorkouts, AddWorkout, EditWorkout, DeleteWorkout, SetExercisesForWorkout, RemoveExerciseFromWorkout, GetWorkoutExercises, GetWorkoutExercisesCandidates, MarkWorkoutFavourite, GetWorkoutCircuitData, GetWorkoutRecords, GetTrainingPlan, GetTrainingPlans, AddTrainingPlan, EditTrainingPlan, DeleteTrainingPlan, SetWorkoutsForTrainingPlan, RemoveWorkoutFromTrainingPlan, GetTrainingPlanWorkouts, GetTrainingPlanWorkoutsCandidates, MarkTrainingPlanFavourite, GetTrainingPlanWorkoutRecords, DeleteFavourite, GetFitnessEditHelperDataTrainingPlan, GetFitnessEditHelperDataWorkout, GetFitnessEditHelperDataExercise) {
        super();
        this.GetHierarchy = GetHierarchy;
        this.GetExercise = GetExercise;
        this.GetExercises = GetExercises;
        this.AddExercise = AddExercise;
        this.EditExercise = EditExercise;
        this.DeleteExercise = DeleteExercise;
        this.StartActiveWorkoutRecord = StartActiveWorkoutRecord;
        this.ConcludeActiveWorkoutRecord = ConcludeActiveWorkoutRecord;
        this.DeleteActiveWorkoutRecord = DeleteActiveWorkoutRecord;
        this.DeleteWorkoutRecord = DeleteWorkoutRecord;
        this.EditWorkoutRecord = EditWorkoutRecord;
        this.GetWorkoutRecord = GetWorkoutRecord;
        this.AddExerciseRecords = AddExerciseRecords;
        this.GetExerciseRecords = GetExerciseRecords;
        this.GetExerciseRecord = GetExerciseRecord;
        this.MarkExerciseFavourite = MarkExerciseFavourite;
        this.GetWorkout = GetWorkout;
        this.GetWorkouts = GetWorkouts;
        this.AddWorkout = AddWorkout;
        this.EditWorkout = EditWorkout;
        this.DeleteWorkout = DeleteWorkout;
        this.SetExercisesForWorkout = SetExercisesForWorkout;
        this.RemoveExerciseFromWorkout = RemoveExerciseFromWorkout;
        this.GetWorkoutExercises = GetWorkoutExercises;
        this.GetWorkoutExercisesCandidates = GetWorkoutExercisesCandidates;
        this.MarkWorkoutFavourite = MarkWorkoutFavourite;
        this.GetWorkoutCircuitData = GetWorkoutCircuitData;
        this.GetWorkoutRecords = GetWorkoutRecords;
        this.GetTrainingPlan = GetTrainingPlan;
        this.GetTrainingPlans = GetTrainingPlans;
        this.AddTrainingPlan = AddTrainingPlan;
        this.EditTrainingPlan = EditTrainingPlan;
        this.DeleteTrainingPlan = DeleteTrainingPlan;
        this.SetWorkoutsForTrainingPlan = SetWorkoutsForTrainingPlan;
        this.RemoveWorkoutFromTrainingPlan = RemoveWorkoutFromTrainingPlan;
        this.GetTrainingPlanWorkouts = GetTrainingPlanWorkouts;
        this.GetTrainingPlanWorkoutsCandidates = GetTrainingPlanWorkoutsCandidates;
        this.MarkTrainingPlanFavourite = MarkTrainingPlanFavourite;
        this.GetTrainingPlanWorkoutRecords = GetTrainingPlanWorkoutRecords;
        this.DeleteFavourite = DeleteFavourite;
        this.GetFitnessEditHelperDataTrainingPlan = GetFitnessEditHelperDataTrainingPlan;
        this.GetFitnessEditHelperDataWorkout = GetFitnessEditHelperDataWorkout;
        this.GetFitnessEditHelperDataExercise = GetFitnessEditHelperDataExercise;
    }
}

export function FitnessService_$reflection() {
    return record_type("Omnicv.Shared.FitnessAPI.FitnessService", [], FitnessService, () => [["GetHierarchy", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [FitnessHierarchy_$reflection()]))], ["GetExercise", lambda_type(option_type(int32_type), lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Exercise_$reflection()])))], ["GetExercises", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Exercise_$reflection())]))], ["AddExercise", lambda_type(Exercise_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [int64_type]))], ["EditExercise", lambda_type(Exercise_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))], ["DeleteExercise", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["StartActiveWorkoutRecord", lambda_type(EventInfo_$reflection(), lambda_type(WorkoutRecord_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [tuple_type(EventInfo_$reflection(), WorkoutRecord_$reflection())])))], ["ConcludeActiveWorkoutRecord", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))], ["DeleteActiveWorkoutRecord", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))], ["DeleteWorkoutRecord", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["EditWorkoutRecord", lambda_type(EventInfo_$reflection(), lambda_type(WorkoutRecord_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [EventInfo_$reflection()])))], ["GetWorkoutRecord", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [tuple_type(EventInfo_$reflection(), WorkoutRecord_$reflection())])))], ["AddExerciseRecords", lambda_type(WorkoutRecordType_$reflection(), lambda_type(EventInfo_$reflection(), lambda_type(list_type(ExerciseRecord_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))))], ["GetExerciseRecords", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(tuple_type(EventInfo_$reflection(), ExerciseRecord_$reflection()))])))], ["GetExerciseRecord", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [tuple_type(EventInfo_$reflection(), ExerciseRecord_$reflection())])))], ["MarkExerciseFavourite", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["GetWorkout", lambda_type(option_type(int32_type), lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Workout_$reflection()])))], ["GetWorkouts", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Workout_$reflection())]))], ["AddWorkout", lambda_type(Workout_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [int64_type]))], ["EditWorkout", lambda_type(Workout_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))], ["DeleteWorkout", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["SetExercisesForWorkout", lambda_type(int32_type, lambda_type(int64_type, lambda_type(list_type(int64_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))))], ["RemoveExerciseFromWorkout", lambda_type(int32_type, lambda_type(int64_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))))], ["GetWorkoutExercises", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Exercise_$reflection())])))], ["GetWorkoutExercisesCandidates", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Exercise_$reflection())])))], ["MarkWorkoutFavourite", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["GetWorkoutCircuitData", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [WorkoutCircuitData_$reflection()])))], ["GetWorkoutRecords", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [WorkoutRecords_$reflection()])))], ["GetTrainingPlan", lambda_type(option_type(int32_type), lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [TrainingPlan_$reflection()])))], ["GetTrainingPlans", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(TrainingPlan_$reflection())]))], ["AddTrainingPlan", lambda_type(TrainingPlan_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [int64_type]))], ["EditTrainingPlan", lambda_type(TrainingPlan_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))], ["DeleteTrainingPlan", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["SetWorkoutsForTrainingPlan", lambda_type(int32_type, lambda_type(int64_type, lambda_type(list_type(int64_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))))], ["RemoveWorkoutFromTrainingPlan", lambda_type(int32_type, lambda_type(int64_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))))], ["GetTrainingPlanWorkouts", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Workout_$reflection())])))], ["GetTrainingPlanWorkoutsCandidates", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Workout_$reflection())])))], ["MarkTrainingPlanFavourite", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["GetTrainingPlanWorkoutRecords", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [TrainingPlanWorkoutRecords_$reflection()])))], ["DeleteFavourite", lambda_type(int32_type, lambda_type(int64_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type])))], ["GetFitnessEditHelperDataTrainingPlan", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [FitnessEditHelperData_$reflection()]))], ["GetFitnessEditHelperDataWorkout", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [FitnessEditHelperData_$reflection()]))], ["GetFitnessEditHelperDataExercise", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [FitnessEditHelperData_$reflection()]))]]);
}

export const fitnessModuleName = "Omnicv.Fitness";

export class FitnessModule {
    constructor() {
        this.initialTimestamp = parse("2022-01-14T20:50:00");
        this.latestTimestamp = this.initialTimestamp;
    }
    get Details() {
        const this$ = this;
        return new ProductInformation(fitnessModuleName, this$.initialTimestamp, this$.latestTimestamp, "Fitness", "Track your fitness performance", empty(), FitnessModule__get_CurrentVersion(this$), singleton(defaultAuthors), defaultContacts, defaultWeb, undefined, undefined, new Changelog(1, [FitnessModule__get_Changelog(this$)]));
    }
    RegisteredTypes() {
        return ofArray([RepsWithWeightRecord_$reflection(), RepsWithBodyWeightRecord_$reflection(), EnduranceRecord_$reflection(), IntervalsDurationRecord_$reflection(), IntervalsRepsRecord_$reflection(), WorkoutRecord_$reflection()]);
    }
}

export function FitnessModule_$reflection() {
    return class_type("Omnicv.Shared.FitnessAPI.FitnessModule", undefined, FitnessModule);
}

export function FitnessModule_$ctor() {
    return new FitnessModule();
}

export function FitnessModule__get_Changelog(this$) {
    return singleton(new ChangelogEntry(this$.initialTimestamp, new Version(1, 0, 1, undefined), "Initial release"));
}

export function FitnessModule__get_CurrentVersion(this$) {
    return head(FitnessModule__get_Changelog(this$)).Version;
}

